export const SET_IS_LOADING = "SET_LOADING_AUTH/uom-page";
export const SET_UOM = "SET_UOM/uom-page";
export const SET_LAST_PARAMS = "SET_LAST_PARAMS/uom-page";
export const SET_PAGINATION_DATA = "SET_PAGINATION_DATA/uom-page";
export const SET_GROUPS = "SET_GROUPS/uom-page";
